import useEffectOnce from "hooks/useEffectOnce";

const JotformAgent = () => {
  useEffectOnce(() => {
    const src =
      "https://cdn.jotfor.ms/agent/embedjs/01957c8b727d7f1ea7a11e4fd9b4fd88b81c/embed.js?skipWelcome=1&maximizable=1";

    // https://cdn.jotfor.ms/agent/embedjs/01965e4fa03c7445a8aae27ec41bf934464a/embed.js?skipWelcome=1&maximizable=1
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (existingScript) return;

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.nomodule = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  });

  return null;
};

export default JotformAgent;
